import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { DoReinforcementFeedback } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class VisualAideCard extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    this.scaleX = 4;
    this.scaleY = 4;

    // desktopView
    const desktopView = scene.add.container(0, 0);
    desktopView.visible = false;
    this.add(desktopView);

    // cardBacking
    const cardBacking = scene.add.image(0, 0, 'Card_48');
    cardBacking.scaleX = 0.5;
    cardBacking.scaleY = 0.5;
    desktopView.add(cardBacking);

    // cardText
    const cardText = scene.add.bitmapText(0, 0, 'Aronui', 'A');
    cardText.setOrigin(0.5, 0.5);
    cardText.tintTopLeft = 6896829;
    cardText.tintTopRight = 6896829;
    cardText.tintBottomLeft = 6896829;
    cardText.tintBottomRight = 6896829;
    cardText.text = 'A';
    cardText.fontSize = -10;
    desktopView.add(cardText);

    // mobileView
    const mobileView = scene.add.container(0, 0);
    this.add(mobileView);

    // cardBacking_m
    const cardBacking_m = scene.add.image(0, 0, 'Card_48');
    cardBacking_m.scaleX = 0.25;
    cardBacking_m.scaleY = 0.25;
    mobileView.add(cardBacking_m);

    // cardText_m
    const cardText_m = scene.add.bitmapText(0, 0, 'Aronui', 'A');
    cardText_m.setOrigin(0.5, 0.5);
    cardText_m.tintTopLeft = 6896829;
    cardText_m.tintTopRight = 6896829;
    cardText_m.tintBottomLeft = 6896829;
    cardText_m.tintBottomRight = 6896829;
    cardText_m.text = 'A';
    cardText_m.fontSize = -7;
    mobileView.add(cardText_m);

    this.cardBacking = cardBacking;
    this.cardText = cardText;
    this.desktopView = desktopView;
    this.cardBacking_m = cardBacking_m;
    this.cardText_m = cardText_m;
    this.mobileView = mobileView;

    /* START-USER-CTR-CODE */
    this.initializeResponsiveness();
    /* END-USER-CTR-CODE */
  }

  public cardBacking: Phaser.GameObjects.Image;
  public cardText: Phaser.GameObjects.BitmapText;
  private desktopView: Phaser.GameObjects.Container;
  public cardBacking_m: Phaser.GameObjects.Image;
  public cardText_m: Phaser.GameObjects.BitmapText;
  private mobileView: Phaser.GameObjects.Container;

  /* START-USER-CODE */
  public cardTextValue: string = 'A';

  getResponsiveElements(key: keyof VisualAideCard) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  setText(text: string) {
    this.getResponsiveElements('cardText').forEach(
      (cardText: Phaser.GameObjects.BitmapText) => {
        cardText.text = text;
      },
    );

    this.cardTextValue = text;
    this.scene.tweens.add({
      targets: this,
      scale: { from: 0, to: 4 }, // Expands from nothing to full size
      angle: 360, // Rotates 360 degrees
      ease: 'Power2', // Eases out smoothly
      duration: 550, // 1 second duration
    });
    PhaserAudioManager.playSFX(this.scene, 'card-reveal-2');
  }

  doReinforcementFeedback() {
    DoReinforcementFeedback(this.scene, this);
  }

  getElementSize() {
    return new Phaser.Math.Vector2(
      this.cardBacking.displayWidth,
      this.cardBacking.displayHeight,
    );
  }

  initializeResponsiveness() {
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
